import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { Toast } from 'antd-mobile'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENTS_RESULT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  QUERY_EXPIRE: null,
  QUERY_FINISH: null,
  ORDERSTATUS_TO_PAYMENTSTATUS_MAPPING: null,
}, 'PAYMENTS_RESULT')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data, count) {
  console.log(data, count)
  // 根据是否包含支付订单号确定查询支付结果还是交易结果
  const endpoint = data.paymentOrderNo
    ? 'cgs/cashdesk/u/queryPayResult'
    : 'cgs/cashdesk/queryTradeOrderDetail'
  return (dispatch, getState) => {
    // 点击refresh按钮重启轮询是重置轮询状态
    if (count === 5) {
      Toast.loading('', 0)
      dispatch({ type: PAYMENTS_RESULT.QUERY_FINISH, payload: false })
      dispatch({ type: PAYMENTS_RESULT.QUERY_EXPIRE, payload: false })
    }
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: endpoint,
        requestAction: PAYMENTS_RESULT.INIT_REQUEST,
        successAction: PAYMENTS_RESULT.INIT_SUCCESS,
        success: function(result) {
          // 路由跳转后中止轮询
          if (getState().router.location.pathname !== '/payments/result') {
            Toast.hide()
            return false
          }

          // 将交易状态的字段转化成支付状态相同的枚举值，方便统一页面处理
          if (!data.paymentOrderNo) {
            const mapping = {
              S: 'SUCCESS',
              F: 'FAIL',
              P: 'PAYING',
            }
            dispatch({
              type: PAYMENTS_RESULT.ORDERSTATUS_TO_PAYMENTSTATUS_MAPPING,
              payload: mapping[result.tradeStatus],
            })
          }

          // 如果交易状态和支付状态都非处理中，中止轮询
          if (
            data.paymentOrderNo
              ? result.paymentStatus !== 'PAYING'
              : result.tradeStatus !== 'P'
          ) {
            Toast.hide()
            dispatch({ type: PAYMENTS_RESULT.QUERY_FINISH, payload: true })
            return false
          }

          // 轮询5次，超出次数后中止轮询显示处理中
          if (count === 1) {
            Toast.hide()
            dispatch({ type: PAYMENTS_RESULT.QUERY_FINISH, payload: true })
            dispatch({ type: PAYMENTS_RESULT.QUERY_EXPIRE, payload: true })
            return false
          }

          // 每3s轮询一次
          setTimeout(() => {
            count--
            dispatch(init(data, count))
          }, 3000)
        },
        error: () => {
          Toast.hide()
          dispatch({ type: PAYMENTS_RESULT.QUERY_FINISH, payload: true })
          dispatch({ type: PAYMENTS_RESULT.QUERY_EXPIRE, payload: true })
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENTS_RESULT.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAYMENTS_RESULT.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAYMENTS_RESULT.QUERY_EXPIRE]: (state, action) =>
    Object.assign({}, state, { queryExpire: action.payload }),
  [PAYMENTS_RESULT.QUERY_FINISH]: (state, action) =>
    Object.assign({}, state, { queryFinish: action.payload }),
  [PAYMENTS_RESULT.ORDERSTATUS_TO_PAYMENTSTATUS_MAPPING]: (state, action) =>
    Object.assign({}, state, { paymentStatus: action.payload }),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentsResult',
    reducerMap: {
      paymentsResultState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
